// import { App } from "@capacitor/app";
// import { Capacitor } from "@capacitor/core";
import { createClient, processLock } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabasePublishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

export const supabase = createClient(supabaseUrl, supabasePublishableKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    // detectSessionInUrl: false,
    // lock: processLock,
  },
  // accessToken: async () => {
  //   return (
  //     (await getAuth().currentUser?.getIdToken(/* forceRefresh */ false)) ??
  //     null
  //   );
  // },
});

// Tells Supabase Auth to continuously refresh the session automatically
// if the app is in the foreground. When this is added, you will continue
// to receive `onAuthStateChange` events with the `TOKEN_REFRESHED` or
// `SIGNED_OUT` event if the user's session is terminated. This should
// only be registered once.
// if (Capacitor.isNativePlatform()) {
//   App.addListener("appStateChange", ({ isActive }) => {
//     if (isActive) {
//       supabase.auth.startAutoRefresh();
//     } else {
//       supabase.auth.stopAutoRefresh();
//     }
//   });
// }
